import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "configContainer", "slackConfig", "httpConfig", "logConfig", "emailConfig", "agentConfig", "connectionSelect", "modelSelect"]
  static values = { index: Number }

  connect() {
    console.log('[TriggerAction] Controller connected, index:', this.indexValue)
    console.log('[TriggerAction] Targets:', {
      hasTypeSelect: this.hasTypeSelectTarget,
      hasSlackConfig: this.hasSlackConfigTarget,
      hasAgentConfig: this.hasAgentConfigTarget,
      hasConnectionSelect: this.hasConnectionSelectTarget,
      hasModelSelect: this.hasModelSelectTarget
    })
  }

  typeChanged(event) {
    const type = event.target.value
    console.log('[TriggerAction] Type changed to:', type)
    this.showConfigForType(type)
  }

  showConfigForType(type) {
    // Hide all config panels
    const configPanels = ['slackConfig', 'httpConfig', 'logConfig', 'emailConfig', 'agentConfig']
    
    configPanels.forEach(panel => {
      const target = this[`has${panel.charAt(0).toUpperCase() + panel.slice(1)}Target`] 
        ? this[`${panel}Target`] 
        : null
      if (target) {
        target.classList.add('hidden')
      }
    })

    // Show the selected config panel
    const configMap = {
      'slack_message': 'slackConfig',
      'http_forward': 'httpConfig',
      'log': 'logConfig',
      'email': 'emailConfig',
      'agent': 'agentConfig'
    }

    const targetName = configMap[type]
    if (targetName && this[`has${targetName.charAt(0).toUpperCase() + targetName.slice(1)}Target`]) {
      this[`${targetName}Target`].classList.remove('hidden')
      console.log('[TriggerAction] Showing config panel:', targetName)
    }
  }

  async connectionChanged(event) {
    console.log('[TriggerAction] Connection changed')
    if (!this.hasModelSelectTarget || !this.hasConnectionSelectTarget) {
      console.log('[TriggerAction] Missing model or connection targets')
      return
    }

    const connectionId = this.connectionSelectTarget.value
    const currentValue = this.modelSelectTarget.value

    console.log('[TriggerAction] Connection ID:', connectionId, 'Current model:', currentValue)

    // Clear existing options and show loading
    this.modelSelectTarget.innerHTML = '<option value="">Loading models...</option>'
    this.modelSelectTarget.disabled = true

    if (!connectionId) {
      this.modelSelectTarget.innerHTML = '<option value="">Select a connection first...</option>'
      this.modelSelectTarget.disabled = false
      return
    }

    try {
      // Fetch models from the connection's test endpoint
      const response = await fetch(`/connections/${connectionId}/test`, {
        headers: { "Accept": "application/json" }
      })
      const data = await response.json()

      console.log('[TriggerAction] API response:', data)

      if (data.success) {
        this.modelSelectTarget.innerHTML = '<option value="">Select a model...</option>'
        
        data.models.forEach(model => {
          const option = document.createElement('option')
          option.value = model.id
          option.textContent = model.display_name || model.id
          if (model.id === currentValue) {
            option.selected = true
          }
          this.modelSelectTarget.appendChild(option)
        })
        
        console.log('[TriggerAction] Loaded', data.models.length, 'models from API')
      } else {
        this.modelSelectTarget.innerHTML = `<option value="">Error: ${data.error}</option>`
        console.error('[TriggerAction] API error:', data.error)
      }
    } catch (error) {
      this.modelSelectTarget.innerHTML = `<option value="">Error: ${error.message}</option>`
      console.error('[TriggerAction] Fetch error:', error)
    }

    this.modelSelectTarget.disabled = false
  }

  remove() {
    console.log('[TriggerAction] Removing action row')
    this.element.remove()
    
    // Dispatch event so parent can update indices if needed
    document.dispatchEvent(new CustomEvent('trigger-action:removed', {
      detail: { index: this.indexValue }
    }))
  }
}
